import _ from 'lodash';
import { ref } from '@vue/composition-api';
import { $api } from '@/store/ApiClient';
import store from '@/store';
import { generateUuid } from '@/utils/searchUtil.js';
import sampleData from '@/sampleData/tradinglist-fetch.json';

// const isMock = true;
const isMock = false;

export function useBffTradingSearch(initialQueries = {}, immediate = true) {
  const data = ref(null);
  const tradingList = ref(null);
  const flowInfo = ref(null);
  const loading = ref(false);
  const error = ref(null);
  const cancelRequestSources = [];
  const tag = generateUuid();
  cancelRequestSources.push(tag);
  let requestSeq = 0;

  const flatten = (ary, target) => {
    return _.map(ary, o => {
      return { ..._.omit(o, [target]), ...o.linkageInfo };
    });
  };

  const fetchData = async (queries = initialQueries) => {
    const mySeq = ++requestSeq;
    loading.value = true;
    error.value = null;
    const params = {
      lslConfig: {
        serviceCode: 'tw-transaction-bff-api',
        apiCode: 'get_/v1/tradings/search',
        query: queries,
      },
      tag: cancelRequestSources,
    };
    try {
      if (isMock) {
        data.value = sampleData;
        const list = flatten(sampleData.tradingFlowList, 'linkageInfo');
        tradingList.value = list;
      } else {
        const res = await $api.request(params);
        if (mySeq !== requestSeq) return;
        data.value = res;
        tradingList.value = flatten(res.tradingFlowList, 'linkageInfo');
        flowInfo.value = _.find(tradingList.value, {
          tradingFlowId: queries.tradingFlowId,
        });
      }

      if (!_.isEmpty(data.value.ownerSectionLists)) {
        store.commit('SET_OWNER_SECTION_LISTS', _.map(data.value.ownerSectionLists, s => {
          return {
            ...s,
            label: s.sectionShortName,
            value: s.sectionId,
          }
        }));
      }
    } catch (err) {
      if (mySeq !== requestSeq) return;
      error.value = err;
      if (!err.isCanceled) {
        data.value = null;
        tradingList.value = [];
      }
    } finally {
      if (mySeq === requestSeq) loading.value = false;
    }
  };

  if (immediate) fetchData();

  return {
    data,
    tradingList,
    flowInfo,
    loading,
    error,
    refresh: fetchData, // 外から fetchData(新しいquery) できるように
  };
}
